export const getDateTime = (n: number | null | undefined, isSecond = false): string => {
  if (!n) {
    return '';
  }

  const time = new Date(n * 1000);
  const day = time.getDate();
  const month = time.getMonth() + 1;
  const year = time.getFullYear();
  const hour = time.getHours();
  const min = time.getMinutes();
  const second = time.getSeconds();
  const minuteTime = `${day < 10 ? `0${day}` : day}/${month < 10 ? `0${month}` :
    month}/${year} ${hour < 10 ? `0${hour}` : hour}:${min < 10 ? `0${min}` : min}`;

  if (isSecond) return `${minuteTime}:${second < 10 ? `0${second}` : second}`;

  return minuteTime;
};

export const getDateTimestamp = (d: Date | string | number | undefined): number => {
  const date = new Date(d || 0);

  return date.getTime() / 1000;
};
